export default __webpack_public_path__ + "static/logo-pphe-7c78fdbf17f797aa0a4a7456a3e71946.png";